
import { FlowDefinition } from "../../../core/flows/FlowDefinition";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { ticketOptionInitStepDefinition } from "./Steps/TicketOptionPageInitStep";
import { ticketOptionStepDefinition } from "./Steps/TicketOptionPageStep";
import { TicketOptionTransition } from "./Transition/TicketOptionTransition";

export const ticketOptionStartupFlow = new FlowDefinition("TicketOptionFlow");

ticketOptionStartupFlow.addStep(ticketOptionInitStepDefinition);
ticketOptionStartupFlow.addStep(ticketOptionStepDefinition);

ticketOptionStartupFlow.addLink("TicketOptionInit_Step", "TicketOption_Step")

ticketOptionStartupFlow.addTransition(TicketOptionTransition, "TicketOptionInit_Step");

ticketOptionStartupFlow.setStartStep("TicketOptionInit_Step");

export const ticketOptionMainStepDefinition = new StepDefinition({
    stepName: "TicketOptionFlow",
    stepFlow: ticketOptionStartupFlow,  
    contextIsolation: false
})